<svg id="Layer_2"
    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <g id="Layer_1-2">
        <polygon class="filled" points="12.05 3.22 5.21 10.07 6.48 11.34 13.32 4.5 13.32 7.26 15.12 7.26 15.12 1.42 9.26 1.42 9.26 3.22 12.05 3.22"/>
        <path class="filled" d="M13.32,13.12H3.42V3.22h4.03v-1.8H2.82c-.66,0-1.19.53-1.19,1.19v11.11c0,.66.53,1.19,1.19,1.19h11.11c.66,0,1.19-.53,1.19-1.19v-4.67h-1.8v4.07Z"/>
        <rect fill="none" class="cutout" width="16" height="16"/>
    </g>
</svg>
